import React, { useState, useEffect } from "react";
import Button from "./Button";
import {
  ClipboardImport,
  Coffee,
  Document,
  Element3,
  ElementPlus,
  Grid4,
  MenuBoard,
  Profile2User,
  Sms,
  Tag,
  Timer1,
} from "iconsax-react";
import Grouping from "./Grouping";
import {
  CHECKIN,
  DASHBOARD,
  DIETARY_EDIT,
  DIETARY_MANAGEMENT,
  EVENT_INFO,
  GUEST_ADD,
  GUEST_EDIT,
  GUEST_LIST,
  GUEST_BULK_PREVIEW,
  GUEST_LIST_IMPORT_LOG,
  MESSAGE_BLAST,
  MESSAGE_BLAST_ADD,
  MESSAGE_BLAST_EDIT,
  REPORT_OVERVIEW,
  SEATS_MANAGEMENT,
  GUEST_LIST_IMPORT_LOG_DETAILS,
  CHANGE_LOG,
  TAG_MANAGEMENT,
  TAG_MANAGEMENT_EDIT,
} from "../Router/path";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = ({ hideSidebarOnclick }) => {
  const [seat, setSeat] = useState(sessionStorage.getItem("seat") === "true");
  const [dietary, setDietary] = useState(
    sessionStorage.getItem("dietary") === "true"
  );

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleStorageChange = () => {
      setSeat(sessionStorage.getItem("seat") === "true");
      setDietary(sessionStorage.getItem("dietary") === "true");
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [location.pathname]);

  const setupGroupConfig = [
    {
      name: "event",
      icon: <Grid4 size="18" variant="Bold" />,
      title: "Event Page",
      navigate: [EVENT_INFO],
      permissions: "view_event_page",
    },
    {
      name: "guest",
      icon: <Profile2User size="18" variant="Bold" />,
      title: "Guest List",
      navigate: [GUEST_LIST, GUEST_ADD, GUEST_EDIT, GUEST_BULK_PREVIEW],
      permissions: "view_guest_list",
    },
    {
      name: "message",
      icon: <Sms size="18" variant="Bold" />,
      title: "Message Blast",
      navigate: [MESSAGE_BLAST, MESSAGE_BLAST_ADD, MESSAGE_BLAST_EDIT],
      permissions: "view_message_blast",
    },
  ];

  const reportGroupingConfig = [
    {
      name: "report",
      icon: <Document size="18" variant="Bold" />,
      title: "Report",
      navigate: [REPORT_OVERVIEW],
      condition: true,
      permissions: "view_report",
    },
    {
      name: "seat",
      icon: <ElementPlus size="18" variant="Bold" />,
      title: "Seat Management",
      navigate: [SEATS_MANAGEMENT],
      condition: seat,
      permissions: "view_seat_management",
    },
    {
      name: "tags",
      icon: <Tag size="18" variant="Bold" />,
      title: "Tag Management",
      navigate: [TAG_MANAGEMENT, TAG_MANAGEMENT_EDIT],
      condition: true,
      permissions: "view_tag_management",
    },
    {
      name: "dietary",
      icon: <Coffee size="18" variant="Bold" />,
      title: "Special Dietary Management",
      navigate: [DIETARY_MANAGEMENT, DIETARY_EDIT],
      condition: dietary,
      permissions: "view_special_dietary",
    },
    {
      name: "guestListImportLog",
      icon: <ClipboardImport size="18" variant="Bold" />,
      title: "Guest List Import Log",
      navigate: [GUEST_LIST_IMPORT_LOG, GUEST_LIST_IMPORT_LOG_DETAILS],
      condition: true,
      permissions: "view_guest_import_log",
    },
        {
      name: "changeLog",
      icon: <Timer1 size="18" variant="Bold" />,
      title: "Change Log",
      navigate: [CHANGE_LOG],
      condition: true,
      permissions: "view_guest_import_log",
    },
  ];

  // const adminGroupingConfig = [
  //   {
  //     name: "userManagement",
  //     icon: <Profile2User size="18" variant="Bold" />,
  //     title: "User Management",
  //     navigate: [USER_LIST, USER_CREATE, USER_EDIT],
  //     condition: true,
  //     permissions: "view_user",
  //   },
  // ];

  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");

  const setupGroup = setupGroupConfig.filter((item) =>
    permissions.includes(item.permissions)
  );

  const reportGrouping = reportGroupingConfig.filter((item) =>
    permissions.includes(item.permissions)
  );

  // const adminGrouping = adminGroupingConfig.filter((item) =>
  //   permissions.includes(item.permissions)
  // );

  return (
    <div
      className="flex xl:sticky xl:top-0 xl:w-fit h-full z-10 xl:z-0"
    >
      <div
        className="flex flex-col min-w-[320px] max-w-[320px] h-full bg-white border-r border-[#EFF0F2] py-[24px] px-[16px] gap-[24px] no-scrollbar overflow-y-auto"
      >
        <div>
          {sessionStorage.getItem("permissions").includes("view_dashboard") && (
            <Button
              name="dashboard"
              variant={
                location.pathname === DASHBOARD ? "sidebar_active" : "sidebar"
              }
              className="w-full text-start"
              onClick={() => {
                if (!window.matchMedia("(min-width: 1025px)").matches) {
                  hideSidebarOnclick();
                }
                navigate(DASHBOARD);
              }}
            >
              <Element3 size="18" variant="Bold" />
              Dashboard
            </Button>
          )}
        </div>

        {/* Setup grouping */}
        {setupGroup.length > 0 && (
          <Grouping name="Setup">
            <div className="flex flex-col gap-[8px]">
              {setupGroup.map((item, index) => (
                <Button
                  key={index}
                  name={item.name}
                  variant={
                    item.navigate.some((path) =>
                      location.pathname.includes(path)
                    )
                      ? "sidebar_active"
                      : "sidebar"
                  }
                  className="w-full text-start"
                  onClick={() => {
                    if (!window.matchMedia("(min-width: 1025px)").matches) {
                      hideSidebarOnclick();
                    }
                    navigate(item.navigate[0]);
                  }}
                >
                  {item.icon}
                  {item.title}
                </Button>
              ))}
            </div>
          </Grouping>
        )}

        {/* Event Day Grouping */}
        {sessionStorage.getItem("permissions").includes("check_in") && (
          <Grouping name="Event Day">
            <div className="flex flex-col gap-[8px]">
              <Button
                name="checkIn"
                variant={
                  location.pathname === CHECKIN ? "sidebar_active" : "sidebar"
                }
                onClick={() => {
                  if (!window.matchMedia("(min-width: 1025px)").matches) {
                    hideSidebarOnclick();
                  }
                  navigate(CHECKIN);
                }}
              >
                <MenuBoard size="18" variant="Bold" />
                Check In
              </Button>
            </div>
          </Grouping>
        )}

        {/* Reports & Management Grouping */}
        {reportGrouping.length > 0 && (
          <Grouping name="Reports & Manage">
            <div className="flex flex-col gap-[8px]">
              {reportGrouping.map(
                (item, index) =>
                  item.condition && (
                    <Button
                      key={index}
                      name={item.name}
                      variant={
                        item.navigate.some((path) =>
                          location.pathname.includes(path)
                        )
                          ? "sidebar_active"
                          : "sidebar"
                      }
                      className="w-full text-start"
                      onClick={() => {
                        if (!window.matchMedia("(min-width: 1025px)").matches) {
                          hideSidebarOnclick();
                        }
                        navigate(item.navigate[0]);
                      }}
                    >
                      {item.icon}
                      {item.title}
                    </Button>
                  )
              )}
            </div>
          </Grouping>
        )}

        {/* Admin Grouping */}
        {/* {adminGrouping.length > 0 && (
          <Grouping name="Admin">
            <div className="flex flex-col gap-[8px]">
              {adminGrouping.map(
                (item, index) =>
                  item.condition && (
                    <Button
                      key={index}
                      name={item.name}
                      variant={
                        item.navigate.some((path) =>
                          location.pathname.includes(path)
                        )
                          ? "sidebar_active"
                          : "sidebar"
                      }
                      className="w-full text-start"
                      onClick={() => {
                        if (!window.matchMedia("(min-width: 1025px)").matches) {
                          hideSidebarOnclick();
                        }
                        navigate(item.navigate[0]);
                      }}
                    >
                      {item.icon}
                      {item.title}
                    </Button>
                  )
              )}
            </div>
          </Grouping>
        )} */}
      </div>
    </div>
  );
};

export default Sidebar;
